'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:EstimatedHoursServiceCtrl
 * @description
 * # EstimatedHoursCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.services')
  .factory('EstimatedHours', ['$http', 'domain', 'BaseService', 'toaster', function ($http, domain, BaseService, toaster) {
    var BASE_ESTIMATED_HOURS_URL = domain.name + '/api/v1/estimated_work_hours/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_ESTIMATED_HOURS_URL,
      baseModelName: 'estimated_work_hour'
    });

    baseService.error = function(error) {
      if(error && error.status === 422) {
        toaster.pop('error', 'Error');
      }
      baseService.baseError(error);
    };

    return baseService;
  }]);
